module.exports = __webpack_public_path__ + "img/otf3.c8258277.png";